import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { FacturaModel } from './Factura.model';


@Component({
	selector : 'factura',
	templateUrl : './FacturaIndex.component.html',
	styleUrls  : ['../../../../styles.css']

})
export class FacturaIndexComponent {
	
	
	public listadoFacturas:Array<FacturaModel>;	
	public cnumcont:string = "";
	public valid:boolean = false;
	public procesando:boolean = false;
	public check:boolean = false;

	public displayedColumns = ['select', 'Contrato', 'Nombre Contrato', 'Prefijo', '#Documento', 'fecha', 'Valor Total'];
	public dataDataBase:FacturaDatabase;
	public dataSource:ExampleDataSource;

	public ocultar: boolean = false;
	public mensaje: string = "";

	public btnConsultar:boolean;	



/*	public dataDataBase:NegociosDatabase;
	public dataSource:ExampleDataSource;
	*/
	@ViewChild('filter') filter: ElementRef;



	constructor(private formBuilder: FormBuilder, private _serviciosGenerales:ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router:Router, public dialog: MatDialog){		
		
		this.listadoFacturas = new Array();

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();
	}


	ngOnInit(){
		
		this.cargarTabla();

	}


	validarCheck(){
		for(let x in this.dataDataBase.data){
			this.dataDataBase.data[x].enviar = this.check;
		}
		this.validar();
	}
	cargarTabla(){
		this.dataDataBase = new FacturaDatabase();

		this._serviciosGenerales.get('listadoFacturas', {param:0}).subscribe(
			
			result=>{

				for(let x in result)
					this.dataDataBase.addFactura( new FacturaModel(false, 
						result[x].cnumcont,
						result[x].vnombrenegocio,
						result[x].ciddoc,
						result[x].cnumdoc,
						result[x].ctipid,
						result[x].cnumid,
						result[x].vnumliq,
						result[x].dfecmov,
						result[x].valor,
						result[x].cidregter,
						result[x].nombreCliente) );
				
				this.dataSource = new ExampleDataSource(this.dataDataBase);
				this.validar();
			},
			error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar las facturas pendientes", "X");
			});

		Observable.fromEvent(this.filter.nativeElement, 'keyup')
		.debounceTime(150)
		.distinctUntilChanged()
		.subscribe(() => {
			if ( !this.dataSource )
			{
				return;
			}
			this.dataSource.filter = this.filter.nativeElement.value;
		});

	}


	enviarFacturas(){
		this.procesando = true;
		let facturas:Array<FacturaModel> = new Array();
		for(let x in this.dataDataBase.data){
			if(this.dataDataBase.data[x].enviar == true){
				//console.log(this.dataDataBase.data[x]);
				facturas.push(this.dataDataBase.data[x]);
			}
		}
		this._serviciosGenerales.post('send', facturas).subscribe(
			result=>{
				this.procesando = false;
				//console.log('resultado: ', result);
				this.cargarTabla();
				if(result.error == false){
					this.openSnackBar(result.mensaje, "X");
					return;
				}else{
					let dialogRef = this.dialog.open(ResultadoEnvio, {
						data:result.mensaje
					});
				}
			},error=>{
				this.procesando = false;
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de enviar las facturas", "X");
			})
	}

	validar(){
		//console.log("entró....");
		let c = 0;
		for(let x in this.dataDataBase.data){
			if(this.dataDataBase.data[x].enviar == true)
				c = c + 1;
		}
		if(c == 0){
			this.valid = false;
			this.check = false;
		}
		else{
			this.valid = true;
			this.check = false;
		}
	}


	filtroContrato(val: string)//: string[]
	{
		if(val == null){
			val = "";
		}
		
		this.dataDataBase.data.filter(facturaModel =>{

		})
		
	}

	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1 notas");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}
	

}





// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

export class FacturaDatabase
{
	
	dataChange: BehaviorSubject<FacturaModel[]> = new BehaviorSubject<FacturaModel[]>([]);

	get data(): FacturaModel[]
	{
		return this.dataChange.value;
	}

	addFactura(factura:FacturaModel)
	{
		const copiedData = this.data.slice();
		copiedData.push(factura);
		this.dataChange.next(copiedData);
	}

}


export class ExampleDataSource extends DataSource<any>
{
	_filterChange = new BehaviorSubject('');

	get filter(): string
	{
		return this._filterChange.value;
	}

	set filter(filter: string)
	{
		console.log(filter);
		this._filterChange.next(filter);
	}

	constructor(private _exampleDatabase: FacturaDatabase)
	{
		super();
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<FacturaModel[]>
	{
		const displayDataChanges = [
		this._exampleDatabase.dataChange,
		this._filterChange
		];

		return Observable.merge(...displayDataChanges).map(() => {
			return this._exampleDatabase.data.slice().filter((item: FacturaModel) => {
				let searchStr = (item.ciddoc+item.cnumcont+item.cnumdoc+item.cnumid+item.ctipid+item.valor).toLowerCase();
				return searchStr.indexOf(this.filter.toLowerCase()) != -1;
			});
		});
	}

	disconnect()
	{
	}
}

@Component({
	selector: 'dialogoResultadoEnvio',
	templateUrl: 'ResultadosEnvio.component.html',
})
export class ResultadoEnvio {
	public mensajes:Array<String>;
	constructor(
		public dialogRef: MatDialogRef<ResultadoEnvio>,
		@Inject(MAT_DIALOG_DATA) public data:Array<string>) {
		//console.log(data);
		this.mensajes = data;
	}

	onNoClick(): void {
		this.dialogRef.close();
	}

}


// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/EnviarFacturas/FacturaIndex.component.ts